import React from "react";
//#region types
import { TimeReportingFormTypes } from "models/formTypes";
import { WintSuperkollAPIModelTimeReporting as ApiModel } from "wint-api-client/dist/types";
import { TimeReportingProjectListViewContainerProps } from "models/propTypes/timeReportingProjectPropTypes";
//#endregion
//#region components
import { Skeletons, useFilterContext } from "components/common";
import { TimeLogsFormContainer } from "components/timeReporting";
import { useTimeReportingService, useTimeReportingInvoiceService } from "serviceHooks";
//#endregion

const TimeReportingProjectListViewContainer: React.FC<TimeReportingProjectListViewContainerProps> = (props) => {
  const timeReportingService = useTimeReportingService();
  const timeReportingInvoiceService = useTimeReportingInvoiceService();
  const { filter } = useFilterContext<TimeReportingFormTypes.Filter>();
  const [reportData, setReportData] = React.useState<ApiModel.TimeReportingReportRow[]>([]);
  const [isLoading, setIsLoading] = React.useState<boolean>(true);
  const { projectId, onInvoiceDocumentationUpdate, reloadKey } = props;

  React.useEffect(() => {
    if (filter) {
      setIsLoading(true);
      fetchReportData();
    }
  }, [filter, reloadKey]);

  React.useEffect(() => {
    if (onInvoiceDocumentationUpdate) {
      const filteredReportData = reportData.filter((row) => (row as any).selected);
      onInvoiceDocumentationUpdate({
        hasUnattestedRecords: timeReportingInvoiceService.hasUnattestedRecords(projectId ?? "", filteredReportData),
        data: timeReportingInvoiceService.mapReportDataToInvoiceDocumentation(
          filteredReportData,
          projectId,
          filter?.period,
          filter?.dateInterval
        ),
      });
    }
  }, [reportData]);

  const getSelectedAndDisabledRows = (
    rows: ApiModel.TimeReportingReportRow[],
    filter: TimeReportingFormTypes.Filter | undefined
  ) => {
    const updatedRows = rows.map((row) =>
      row.columns &&
      row.columns[0].hoursToInvoice &&
      filter &&
      (filter.period ||
        ((filter.dateInterval?.end || filter.dateInterval?.start) && filter.onlyIncludeHourlyIndividualBillingModel))
        ? { ...row, selected: true }
        : { ...row, disabled: true }
    );
    return updatedRows ?? [];
  };

  const fetchReportData = () => {
    timeReportingService
      .getReport({
        ...filter,
        projectId,
      })
      .then((res) => {
        setReportData(getSelectedAndDisabledRows(res.data, filter));
        setIsLoading(false);
      });
  };

  const onTimeLogsChange = (updatedRows: ApiModel.TimeReportingReportRow[]) => {
    setReportData(updatedRows);
  };

  return isLoading ? (
    <Skeletons.FormSkeleton></Skeletons.FormSkeleton>
  ) : (
    <TimeLogsFormContainer
      dataRows={reportData}
      onTimeReportRowsChange={onTimeLogsChange}
      allowCheckBoxSelection={true}
      hiddenColumns={["utilizationRate"]}
      compactTable={true}
    ></TimeLogsFormContainer>
  );
};

export default TimeReportingProjectListViewContainer;
